import React, { useEffect } from 'react';
import { useNavigate, useLocation, NavLink, Outlet, Navigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { LayoutTemplate, MessageSquare, Settings, Brain, FileText, MoveRight, Building2 } from 'lucide-react';
import { SiGoogleadsense as LeadsIcon } from "react-icons/si";
import { Box }  from '@mui/material';
import { useReduxLeads } from '@Hooks/reduxLeadsHook/useReduxLeads';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import { useReduxTemplateFiles } from '@Hooks/reduxTemplateFilesHook/useReduxTemplateFiles';
import KaiziqLeadsConnectionService from '@Helpers/URLHelpers/WeboutService/KaiziqLeadsConnectionService';
import WhatsappHeader from '@Whatsapp/WhatsappHeader';
import ProjectService from '@Helpers/URLHelpers/ProjectService';
import ErrorHandler from '@Root/ErrorHandler';

function WhatsappDataLoader() {

    const location = useLocation();
    const navigate = useNavigate();
    const { currentProjectId, setCurrentProject } = useReduxProject();
    const { activeUserId } = useReduxActiveUser();
    const { templateFiles, fetchTemplateFileList } = useReduxTemplateFiles();
    const { currentLeads, currentLeadsId, leadsList, setLeadsList, numbersList, setTemplateList, setNumbersList, setPhoneNumber, leadsPaymentInfo, setCurrentLeadsPaymentInfo, currentPhoneNumber } = useReduxLeads();
    const kaiziqLeadsConnectionService = new KaiziqLeadsConnectionService();
    const projectService = new ProjectService();
    const errorHandler = new ErrorHandler();

    useEffect(()=> {
        if(!currentLeads) return;
        if(currentProjectId === 0) {
            fetchProjectList();
        }
        Promise.allSettled([
            fetchNumberList(),
            fetchTemplateList(),
            fetchPaymentStatus()
        ]);
    },[currentLeadsId]);

    const fetchNumberList = async()=> {
        try {
            let phoneNumberList = await kaiziqLeadsConnectionService.getPhoneNumberListByProjectId(currentProjectId);
            if(phoneNumberList.status < 400) {
                phoneNumberList = JSON.parse(phoneNumberList.body);
                if(!!phoneNumberList && phoneNumberList.length > 0) {
                    setNumbersList(phoneNumberList);
                    if(Object.keys(currentPhoneNumber || {}).length === 0) {
                        setPhoneNumber(phoneNumberList[0]);
                    }
                    await fetchTemplateFileList(currentLeadsId);
                } else {
                    navigate('/home/whatsapp/settings');
                }
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const fetchTemplateList = async ()=> {
        try {
            let response = await kaiziqLeadsConnectionService.getTemplateListByLeadsIdWithLimit(currentLeadsId, 50);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                let list = response.data;
                if(!!list) {
                    list = list.filter((item)=> item.status === 'APPROVED');
                    setTemplateList(list);
                }
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const fetchPaymentStatus = async()=> {
        try {
            let response = await kaiziqLeadsConnectionService.getPaymentStatusByLeadsId(currentLeadsId);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                setCurrentLeadsPaymentInfo(response);
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const fetchProjectList = async()=> {
        try {
            let response = await projectService.getProjectListByUserId(activeUserId);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                if(!!response) {
                   let activeProject = response.find(project => project.visibility === 'leads');
                    if(!!activeProject) {
                        setCurrentProject(activeProject);
                    }
                }
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const blockedRoutes = [
        '/home/whatsapp/templates',
        '/home/whatsapp/ai-agent'
    ];

    const isBlockedRoute = blockedRoutes.includes(location.pathname) && !leadsPaymentInfo?.paymentEnable;

    if (isBlockedRoute) {
        return <Navigate to="/home/whatsapp/settings" replace />;
    }

    return <Outlet/>;
}

export default WhatsappDataLoader;
